<div class="heat-map-container" *ngIf="muscleStatistics.length">
  <div>
    <app-body-heatmap [side]="'front'" [exerciseData]="muscleStatistics">
    </app-body-heatmap>
  </div>
  <div>
    <app-body-heatmap [side]="'back'" [exerciseData]="muscleStatistics">
    </app-body-heatmap>
  </div>
</div>

<div *ngIf="workoutPlan" class="px">
  <h2>Average Workout Time:</h2>
  <p class="px" *ngIf="formattedWorkoutTime">{{ formattedWorkoutTime }}</p>
  <p class="px" *ngIf="!formattedWorkoutTime">No valid workouts found</p>
  <p>{{ workoutPlan.planDescription }}</p>
</div>

<!-- Exercise Details List -->
<ion-list *ngIf="exercises.length > 0">
  <ion-item *ngFor="let exercise of exercises" [routerLink]="['/add-sport/exercise', exercise.id]">
    <ion-thumbnail slot="start" class="custom-thumbnail">
      <app-exercise-thumbnail [exercise]="exercise"></app-exercise-thumbnail>
    </ion-thumbnail>
    <ion-label>
      <h2>{{ exercise.sportName }}</h2>
      <p>Sets: {{ exercise.sets }}</p>
      <p *ngIf="exercise.id! | getPr | async as pr">
        Personal best: {{ pr.highestRep }} x {{ pr.highestWeight }}
      </p>
    </ion-label>
  </ion-item>
</ion-list>
